module.exports = __webpack_public_path__ + "kudos_30.svg?a627efc5df000b0c524ee0a81634beb2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_30.svg
// module id = 129
// module chunks = 0